import { Validators } from '@angular/forms';

export class EmailValidators {
  static readonly emailUsername = () => Validators.pattern('^[a-zA-Z0-9._%+-]+$');
  static readonly emailDomain = () => Validators.pattern('^[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$');
  static readonly fullEmailAddress = () => Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$');
}
